import { useQuery } from "@tanstack/react-query";
import {
  liveSensorsResponseSchema,
  type LiveSensor,
} from "@/features/deployment-dashboard/live-view/api/live-sensors-response";
import { useRuntimeHttpClient } from "@/features/runtime-session/hooks/use-runtime-http-client";

const LIVE_SENSORS_PATH = "/v1/live/sensors";
const LIVE_SENSORS_REFETCH_INTERVAL_MS = 10_000;

/** Fetches the deployment-wide live sensor registry when the runtime session grants access. */
export function useLiveSensors(deploymentId: string) {
  const runtime = useRuntimeHttpClient();
  const hasLiveSensorsGrant = runtime.operationGrants.some(
    (grant) => grant.operation_id === "live_sensors_list"
  );
  const client = runtime.client;

  return useQuery<LiveSensor[]>({
    queryKey: ["live-sensors", deploymentId],
    queryFn: async () => {
      const response = await client!.get<unknown>(LIVE_SENSORS_PATH);
      return liveSensorsResponseSchema.parse(response).sensors;
    },
    enabled: Boolean(client) && runtime.deploymentId === deploymentId && hasLiveSensorsGrant,
    refetchInterval: LIVE_SENSORS_REFETCH_INTERVAL_MS,
    refetchIntervalInBackground: false,
  });
}
